export interface MyPageTopicGroupDetail {
  nameZh: string;
  nameEn: string;
  priority: number;
  disabled: boolean;
  topics: string[];
  type?: WaterfallPostTypeEnum;
}

export enum WaterfallPostTypeEnum {
  REPLAY = 'REPLAY',
}
